<template>
  <div class="app-main-content make-invoice">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" :lazy="true" type="card" style="width:100%;">
        <el-tab-pane v-if="$checkPermission(['tab_tabMakeInvoice'])" :label="$t('Invoice.invoice_drawCollectInvoice')" name="makeInvoice">
          <tab-make-invoice :is-show="makeInvoiceIsShow" />
        </el-tab-pane>
        <el-tab-pane v-if="$checkPermission(['tab_tabQueryInvoice'])" :lazy="true" :label="$t('Invoice.invoice_queryInvoice')" name="queryInvoice">
          <tab-invoice-query :is-show="queryInvoiceIsShow" />`
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import tabMakeInvoice from './components/makeInvoice/tabMakeInvoice'
import tabInvoiceQuery from './components/makeInvoice/tabInvoiceQuery'

export default {
  name: 'MakeInvoice',
  components: { searchItem, tabMakeInvoice, tabInvoiceQuery },
  data() {
    return {
      activeTabName: !this.$checkPermission(['tab_tabMakeInvoice']) ? 'queryInvoice' : 'makeInvoice',
      makeInvoiceIsShowed: false,
      queryInvoiceIsShowed: false
    }
  },
  computed: {
    makeInvoiceIsShow() {
      if (this.activeTabName === 'makeInvoice' && !this.makeInvoiceIsShowed) {
        this.makeInvoiceIsShowed = true
      }
      return this.makeInvoiceIsShowed
    },
    queryInvoiceIsShow() {
      if (this.activeTabName === 'queryInvoice' && !this.queryInvoiceIsShowed) {
        this.queryInvoiceIsShowed = true
      }
      return this.queryInvoiceIsShowed
    }
  }
}
String.prototype.format = function() {
  if (arguments.length == 0) return this
  for (var s = this, i = 0; i < arguments.length; i++) { s = s.replace(new RegExp('\\{' + i + '\\}', 'g'), arguments[i]) }
  return s
}
</script>

<style lang="scss">
.make-invoice {
  //.total-detail-popover {
  //  display: flex;
  //  align-items: center;
  //  justify-content: center;
  //  >span {
  //    padding-right: 6px;
  //  }
  //}
  //.el-tabs__content {
  //  padding: 0 !important;
  //  background: #fff;
  //}
  //.dense-radio-group {
  //  .el-form-item {
  //    margin-bottom: 0 !important;
  //    .el-form-item__content {
  //      vertical-align: middle;
  //    }
  //  }
  //  .el-radio {
  //    margin-right: 6px !important;
  //    .el-radio__label {
  //      padding-left: 4px!important;
  //    }
  //  }
  //}
}
</style>
